export default __webpack_public_path__ + "static/media/8.91108da3.png";